import React from 'react'
import styles from './AlbumSeeAll.module.css';
import { useNavigate } from 'react-router';

const AlbumSeeAll = ({data}) => {
  const navigate = useNavigate();
  const skeletonStyles = {
    backgroundColor: "white",
    color: "white", // Set the text color to white
  };

  const handleAlbumClick = (albumId) => {
    navigate(`/music/detail/album/${albumId}`);
  }

  return (
    <div className={`${styles.grid_cols_custom} grid`}>
      {data.map((item) => (
        <div key={item.id} className="inline-block truncate text-center"
        onClick={() => handleAlbumClick(item.id)}
        >
            <img
              src={item.image}
              alt=""
              className="rounded-lg w-100 object-cover aspect-square"
            />
          {/* <img src={item.image} alt="" className="rounded-lg w-100 object-cover aspect-square" /> */}
          <span className="text-xs mt-2">{item.title}</span>
        </div>
      ))}
    </div>
  );
}

export default AlbumSeeAll